export function isCode128PartiallyValid(value: string): boolean {
    const isCode128A = /^([ -/]|\d|[A-Z]|\[-`]|\n)*$/;
    const isCode128B = /^([ -~]|\n)*$/;
    const isCode128C = /^(\d\d|\n)*$/;

    return isCode128A.test(value) || isCode128B.test(value) || isCode128C.test(value);
}
